<template>
  	<div id="FAQDetail" data-role="page">
		<!-- content -->
		<div class="FAQDetail-content" data-position="fixed">
			<div class="detailWrap" style="margin-bottom: 10px">
                <div class="detail-h">
					<span class="cgy-tag">{{chn_tag(FAQDetail.qaType)}}</span>
					<h3>{{FAQDetail.qaTitle}}</h3>
				</div>
				<!-- 問答內容 -->
        <div class="detail-c">
          <div class="txtContent">
						<p v-html="FAQDetail.qaFeedback"></p>
						<!-- <a href="https://www.kingnet-select.com.tw/isp_v3/ispform.html" target="_blank">文章內文連結顏色樣式</a>
						<img src="https://fakeimg.pl/900x675/cccccc/" alt=""> -->
					</div>
					<span class="article_date">{{FAQDetail.qaDate}}</span>
				</div>
				<!-- /問答內容 -->
				<!-- 推+收藏 -->
				<div class="detail-extra">
					<span v-on:click="SetRecommend(qa_id,FAQDetail.is_push)"><i :class="[FAQDetail.is_push ? 'icon-smile-full active' : '','icon-smile']"></i>{{FAQDetail.push_count}}</span>
					<span v-on:click="SetFavorites(qa_id,FAQDetail.is_keep)"><i :class="[FAQDetail.is_keep ? 'icon-bookmark-full active' : 'icon-bookmark','bookmarkIcon']"></i>收藏</span>
				</div>
				<!-- 推+收藏 -->
			</div>
			<div class="detailWrap articleWrap questionnaire" style="margin-bottom: 60px">
				<div class="detail-c">
					<div class="questionnaire">
						<a href="https://docs.google.com/forms/d/e/1FAIpQLSetKmRasOJyXyx4XNOt8g_bFeUpytB5dTVdzRnPkAhAN_Ezzg/viewform">
							<div class="img">
							</div>
							<div class="txt">
								<span class="title">想看什麼快來許願吧！</span>
                                <p class="content">不管你想看甚麼,我們都幫你準備。</p>
							</div>
						</a>
					</div>
				</div>
			</div>			
		</div>
		<!-- /content -->
	    <favoritesToast
        :show="toastControl.show"
        :full="toastControl.full"
        :content="toastControl.content"
        :showTime="toastControl.showTime"
        @close="toastControl.show = false"
        ></favoritesToast>
	</div>
</template>

<script lang="js">
import favoritesToast from '@/components/common/toast/favoritesToast';
export default {
	components: { favoritesToast },
  data () {
    return {
		FAQDetail:[],
		qa_id : this.$route.params.id,
		toastControl:{
            show: false,
            full: false,
            content: '',
            showTime: 1000
        }
    }
  },
  mounted(){
	  this.GetFAQ();
  },
  methods:{
	GetFAQ(){
		let vobj = this;
		let qa_id = this.$route.params.id;
		let FAQTempData = localStorage.getItem('FAQTemp');
		switch (FAQTempData) {
			case null:
				GetData(qa_id,1);
				break;
			case '':
				GetData(qa_id,1);
				break;	  
			default:
				vobj.FAQDetail = JSON.parse(FAQTempData);
				if(vobj.FAQDetail.qa_id == qa_id){
					GetData(qa_id,0);
				}else{
					GetData(qa_id,1);
				}
				break;
		}
		function GetData(id,AppToWeb){
			vobj.axios.get(`${process.env.ExternalApi}/api/ExternalControllers/Committee/GetCommitteeQAFeedback/${id}/${AppToWeb}`,{
				headers:{Authorization: Token}
			}).then((response) => {
				if(response.status == 200){
					if(AppToWeb==0){
						vobj.FAQDetail = JSON.parse(FAQTempData);
						vobj.FAQDetail['qaFeedback']= response.data.data.qaFeedback;
						vobj.FAQDetail['is_keep']= response.data.data.is_keep;
						vobj.FAQDetail['is_push']= response.data.data.is_push;
						vobj.FAQDetail['push_count']= response.data.data.push_count;
						vobj.FAQDetail=JSON.parse(JSON.stringify(vobj.FAQDetail));
						console.log('a');
					}else{
						vobj.FAQDetail = [];
						vobj.FAQDetail = response.data.data;
						console.log(vobj.FAQDetail);
						console.log("b")
					}
				}
			}).catch(function (error) {
				vobj.GetFAQ();
			})
		}
	},
	//回傳標籤名稱
	chn_tag(type){
		return this.$root.GetFAQTypeChn(type);
	},
	//設定收藏
	SetFavorites(id,status){
		let vobj = this;
		if(vobj.toastControl.show) return false
		let status_val = 0;
		status ? (status_val=0 ) : (status_val=1);
		vobj.$root.SetFavorites(1,id,status_val,function(res){
			if(res){	
				vobj.FAQDetail['is_keep'] = status ? (false):(true);
			}
			status ? vobj.UnfavoritesToast() : vobj.FavoritesToast()
		});
	},
	//設定推
	SetRecommend(id,status){
		let vobj = this;
		let status_val = 0;
		status ? (status_val=0 ) : (status_val=1);
		vobj.$root.SetRecommend(1,id,status_val,function(res){
			if(res){
				if(status){
					vobj.FAQDetail['push_count'] -=1;
				}else{
					vobj.FAQDetail['push_count'] +=1;
				}
				vobj.FAQDetail['is_push'] = status ? (false):(true);
				console.log(vobj.FAQDetail);
			}
		});
	},  	
	FavoritesToast(){
		this.toastControl.content = '已加入收藏'
		this.toastControl.full = true
		this.toastControl.show = true
	},
	UnfavoritesToast(){
		this.toastControl.content = '已取消收藏'
		this.toastControl.full = false
		this.toastControl.show = true
	}	
  }
}
</script>



// WEBPACK FOOTER //
// src/components/FAQDetail.vue